export const BREEZE_MEETING_NOTE_TAKER_KNOWLEDGE_BASE_ARTICLE_LINK = 'https://knowledge.hubspot.com/meetings-tool/record-and-take-notes-with-meeting-notetaker';